import axios from 'axios';

export default function setAuthToken(token) {
    if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
}


// WEBPACK FOOTER //
// src/store/utils/setAuthToken.js